<template>
    <div class="ma-2">
        <!-- filter -->
        <v-row class="pb-3 pt-1 px-4">
            <v-col cols="12" lg="auto">
			    <slot name="breadcrumbs" :item="true"></slot>
		    </v-col>
            <v-col cols="12" sm="4" md="2" lg="2" class="px-1">
                <v-autocomplete 
                    v-model="type"
                    :items="invoiceTypes"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    clearable
                    :label="$t('inputs.type')"
                />
            </v-col>
            <v-col v-if="false" cols="6" sm="4" md="2" lg="1" class="px-0" >
                <v-text-field 
                width="100"
                v-model="invoice_no"
                :label="$t('inputs.invoice-no')"
                outlined
                dense
                hide-details
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-autocomplete 
                    v-model="status"
                    :items="invoiceStatus"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    :label="$t('inputs.invoice-status')"
                    clearable
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-autocomplete 
                    v-model="account"
                    :items="accounts"
                    item-text="name"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    :label="$t('inputs.account')"
                    clearable
                />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="2" class="px-1">
                <v-text-field 
                v-model="notes"
                :label="$t('inputs.notes')"
                outlined
                dense
                hide-details
                />
            </v-col>
            <v-col></v-col>
            <v-col cols="auto">
                <v-btn dark color="blueGray" @click="getInvoices()" class="ml-3">
                    {{$t('update')}}
                </v-btn>
            </v-col>
        </v-row>

        <bee-handy-table
            ref="table"
            :headers="headers"
            :items="invoices"
            :loading="loading"
            fixed-header
            dense
            zebra
            :height="$vuetify.breakpoint.height - 160"
            :items-per-page="-1"
            hide-default-footer
        >
            <!-- <template v-slot:item.is_posted="{ item }">
                <span :class="item.is_posted ? 'success--text'  : ' unpostedColor--text'">
                    {{ item.is_posted ? $t('posted') : $t('unposted') }}
                </span>
            </template> -->
            <template v-slot:item.is_posted="{ item }">
                <v-chip 
                    :color="
                        item.posting_type === postingType.bond || item.posting_type === postingType.materialsJournal
                        ? 'yellow darken-4'
                        :item.is_posted
                            ? 'postedColor' 
                            : 'unpostedColor'" 
                        dark
                >
                    <span class="mx-1">
                        {{
                            item.posting_type === postingType.both
                                ?$t('invoices.fully-posted')
                                : item.posting_type === postingType.bond
                                    ? $t('invoices.warehouse-non-posted') 
                                    : item.posting_type === postingType.materialsJournal
                                        ? $t('invoices.non-posted-for-accounting')
                                            :item.is_posted
                                                ? $t('posted')
                                                : $t('unposted')   
                        }}
                    </span>
                    <v-icon left dark small class="mx-1">{{ item.is_posted ? 'fa-envelope' : 'fa-envelope-open' }}</v-icon>
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-tooltip bottom v-if="item.order_id">
                        <template v-slot:activator="{on, attrs}">
                            <v-btn
                                v-on="on"
                                v-bind="attrs"
                                icon
                                color="primary"
                                @click="redirectToOrder(item.order_id)"
                            >
                                <v-icon>
                                    mdi-file-document-arrow-right-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        {{$t('AllInvoicesPage.show-order')}}
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn 
                                v-on="on"
                                v-bind="attrs"
                                icon 
                                color="success" 
                                @click="redirectToInvoice(item.id, item.type)"
                            >
                                <v-icon>
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                        </template>
                        {{$t('AllInvoicesPage.show-invoice')}}
                    </v-tooltip>

                </div>
            </template>
    </bee-handy-table>
    </div>
</template>
<script>
import { invoicesTypes, invoiceStatuses, invoiceType, invoicesPostingTypeStatuses, postingPriorityType,postingType, userType } from '@/helpers/enums'
import { mapGetters, mapState } from 'vuex'
export default {
    data() {
        return {
            type: null,
            items: [],
            loading: false,
            invoices: [],
            invoicesTypes,
            invoiceType,
            invoiceStatuses,
            invoicesPostingTypeStatuses,
            postingPriorityType,
            postingType,
            itemId: null,
            notes: null,
            status: null,
            account: null,
            invoice_no: null
        }
    },

    watch: {
        '$route.query.type'(val) {
            if(val) {
                this.type = val
            }
        }
    },

    computed: {
        headers() {
            const headers= [
                {
                    text: this.$t('invoices.invoice-no'),
                    name: 'invoiceNo',
                    value: 'no',
                    sortable: false
                },
                {
                    text: this.$t('headers.type'),
                    name: 'type',
                    value: 'type',
                    setValueExpr: val => this.invoicesTypes.find(c => c.id === val)?.name,
                    sortable: false
                },
                {
                    text: this.$t('headers.account'),
                    name: 'account',
                    value: 'external_account_id',
                    setValueExpr: val => this.getAccountById(val)?.name,
                    sortable: false
                },
                {
                    text: this.$t('headers.state'),
                    name: 'is_posted',
                    value:'is_posted',
                    sortable: false
                },
                !this.isWarehousePermission 
                    ? {
                        text: this.$t('headers.total'),
                        name: 'total',
                        value: 'total_net.amount',
                        sortable: false
                    } 
                    : null,
                {
                    text: this.$t('headers.notes'),
                    name: 'notes',
                    value: 'notes',
                    sortable: false
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    width: 120,
                    sortable: false
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    width:50,
                    sortable: false
                },
            ]
            return headers.filter(v => Boolean(v))
        },
        ...mapGetters({
            getAccountById: 'configs/getAccountById',
            getSettingByKey: 'settings/getSettingByKey'
        }),
        ...mapState({
            accounts: state => state.configs.configs.accounts,
            userTypePermission: state => state.permissions.user_type,
        }),
        invoiceTypes() {
            let invoices = invoicesTypes
            invoices.unshift({
                name: this.$t('all'),
                id: 0
            })
            return invoices
        },
        invoiceStatus() {
            let status = this.postingPattern? invoicesPostingTypeStatuses:invoiceStatuses;
            status.unshift({
                name: this.$t('all'),
                id: !this.postingPattern? 0: null
            })
            return status
        },
        postingPattern() {
            return this.getSettingByKey('Posting Pattern').setting_value !== postingPriorityType.both;
        },
        isWarehousePermission() {
			return (this.userTypePermission === userType.warehouseKeeper) || (this.userTypePermission === userType.warehouseManger)
    	},
    },

    methods: {
        getInvoices() {
            this.loading = true
            this.$store.dispatch('invoices/fetchInvoices', { 
                invoiceType: this.type || null,
                notes :this.notes ,
                accountId: this.account,
                status: !this.postingPattern? this.status: null,
                postingTypeAdvance: this.postingPattern?this.status:null,
                invoice_no: this.invoice_no
            }).then((data) => {
                this.$refs.table.resetShownRows()
                this.invoices = data
            }).finally(() => {
                this.loading = false
            })
        },
        redirectToInvoice(id, type) {
            const route = this.$router.resolve({
                name: 
                    type === this.invoiceType.buy ? 'invoices-buy' 
                    : type === this.invoiceType.sale ? 'invoices-sale' 
                    : type === this.invoiceType.buyRefund ? 'buy-invoice-refund' 
                    : type === this.invoiceType.saleRefund ? 'sale-invoice-refund' 
                    : null,

                params: { id: id },
                query: {
                    withCategory: true
                }
            });
            window.open(route.href, '_blank');
        },
        redirectToOrder(id) {
            const route = this.$router.resolve({
                name: 'buy-order',
                params: {id: id}
            })
            window.open(route.href, '_blank');
        }
    },
    mounted() {
        /*when come from one of invoices to show un posted invoices*/
        this.type  = +this.$route.query.type || 0
        this.status = +this.$route.query.status || null
        this.getInvoices()
    }
}
</script>
<!-- fetchInvoicesNoPosted -->
<style >
</style>